export const GET_TALOAD="GET_TALOAD"

export const GET_TALOAD_REQUEST="GET_TALOAD_REQUEST"
export const GET_TALOAD_SUCCESS="GET_TALOAD_SUCCESS"
export const GET_TALOAD_FAILUER="GET_TALOAD_FAILUER"